var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTfuel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m21.352 15.235.007-.002c.661-.222 1.726-.58 1.79-2.83.178.272.43.563.715.894 1.358 1.571 3.486 4.036 2.118 9.59-.674 2.622-3.184 3.896-5.55 4.86-1.476.628-2.984 1.677-3.596 3.253 0 0-11.177-1.412-10.83-12.513.177-3.621 2.375-5.835 4.551-8.027 1.285-1.293 2.561-2.579 3.41-4.141 1.216-2.657.803-5.32.803-5.32s7.118 4.427 3.904 11.25c-1.045 2.41 1.45 3.226 2.678 2.985zm-10.982 1.99v3.711h3.941v3.942h3.713v-3.942h3.942v-3.712H10.37zm12.937-6.316c.05-.137.103-.28.188-.382.09-.095.2-.178.316-.265.39-.293.84-.63.757-1.648-.087-1.594-.982-2.72-1.543-3.426a6.81 6.81 0 0 1-.332-.44c.053 1.318-.212 1.644-.543 2.048a4.116 4.116 0 0 0-.3.4c-1.657 3.028 1.033 4.057 1.033 4.057.25.127.332-.095.424-.346z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTfuel);
export default __webpack_public_path__ + "static/media/TFUEL.781c5822f8116f9dbcd27c6ac2c055b3.svg";
export { ForwardRef as ReactComponent };